import React from 'react';

function Contacts() {
  return (
    <section id="contacts" className="p-5 bg-primary-gradient shadow-inner-sm">
      <div className="container my-5">


        <div className='row justify-content-center'>
          <div className='col-md-8 text-center py-5'>
            
            <div className='row mb-5'>
              <div className='col'>
                <a className='btn btn-lg fs-1' href='https://www.linkedin.com/in/rocco-macellaro-15660349/'>
                  <i className="bi bi-linkedin"></i>
                </a>
              </div>

              <div className='col'>
                <a className='btn btn-lg fs-1' href='https://github.com/rmacellaro'>
                  <i className="bi bi-github"></i>
                </a>
              </div>              

              <div className='col'>
                <a className='btn btn-lg fs-1' href='https://www.facebook.com/rocco.macellaro.7'>
                  <i className="bi bi-facebook"></i>
                </a>
              </div>

              <div className='col'>
                <a className='btn btn-lg fs-1' href='https://www.instagram.com/macellarorocco/'>
                  <i className="bi bi-instagram"></i>
                </a>
              </div>

              <div className='col'>
                <a className='btn btn-lg fs-1' href='https://500px.com/p/RoccoMacellaro'>
                  500<span style={{fontSize: '0.9rem'}}>px</span>
                </a>
              </div>

            </div>

            <div className='fst-italic mb-5'>
              <span>"</span>
                <span className='lh-sm'>La fortuna capita, </span>
                <span className='lh-sm'>il resto si costruisce ...</span>
              <span>"</span>
            </div>


            <div className='text-muted'>
              <div className='fs-6 lh-sm'>Handcrafted by me</div>
              <div className=''>
                <i className='bi bi-c-circle me-1'></i>
                <span>Rocco Macellaro</span>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </section>
  );
}

export default Contacts;